import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "user-details",
  class: "d-flex flex-fill"
}
const _hoisted_2 = {
  class: "card",
  style: {"border-radius":"12px","border":"0"}
}
const _hoisted_3 = { class: "header card-header" }
const _hoisted_4 = { id: "user-label" }
const _hoisted_5 = {
  class: "card-body overflow",
  id: "card-body"
}
const _hoisted_6 = { id: "user-draft" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "card-footer footer" }
const _hoisted_20 = { style: {"float":"right"} }

import { ElButton } from "element-plus";
import { onBeforeMount, ref } from "vue";
import { cloneDeep } from "lodash-es";
import { getUserById } from "@/user/services/user.service";
import { currentRoute, router } from "@/core/router";
import { hasPermission } from "@/core/auth";
import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetail',
  setup(__props) {

const { t } = i18n.global;
const detailUser = ref({});

const id = ref("");

function convertDate(dateStr) {
  const milliseconds = Date.parse(dateStr);
  const date = new Date(milliseconds);
  return date.toLocaleDateString();
}

onBeforeMount(async () => {
  id.value = currentRoute.value.params.id as string;
  if (id.value) {
    await getUserById(id.value).then((response) => {
      if (response) {
        detailUser.value = cloneDeep(response);
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("User.UserDetails")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Name")), 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(detailUser.value.name), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CreationTime")) + ":", 1)
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(convertDate(detailUser.value.createdAt)), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.UpdatedAt")) + ":", 1)
            ]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(convertDate(detailUser.value.updatedAt)), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(detailUser.value.username), 1),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Organisation")) + ":", 1)
            ]),
            _createElementVNode("div", _hoisted_16, _toDisplayString(detailUser.value.organisation?.name), 1),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Role")) + ":", 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailUser.value.authorities, (item) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: item.authority
                }, _toDisplayString(item.authority), 1))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/users')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Save")), 1)
            ]),
            _: 1
          }),
          (_unref(hasPermission)('USERS.LIST.EDIT'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "btn-oneTeg",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/users/edit/' + id.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Edit")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})